import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { download } from '../../utils/Common';

export const DWG_GUIDELINES_FILENAME = 'eShow_Floor_Map_v3_DWG_Guidelines.pdf';
export const DWG_GUIDELINES_URL = `${process.env.PUBLIC_URL || ''}/docs/${DWG_GUIDELINES_FILENAME}`;

/** Download the static DWG preparation guidelines PDF from public/docs. */
export const downloadDwgGuidelines = (e) => {
  if (e?.preventDefault) {
    e.preventDefault();
  }
  download(DWG_GUIDELINES_URL, DWG_GUIDELINES_FILENAME);
};

function DwgGuidelinesBanner() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.75,
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        mb: 2,
        mt: 1.5,
        px: 2.5,
        py: 1.75,
        borderRadius: '5px',
        border: '1px solid #7B9DB5',
        backgroundColor: '#E6F4FA',
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.14)',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 48,
          height: 48,
          borderRadius: '50%',
          backgroundColor: '#F5A623',
          color: '#fff',
          flexShrink: 0,
        }}
      >
        <MenuBookOutlinedIcon sx={{ fontSize: 26 }} />
        <Box
          component="span"
          sx={{
            position: 'absolute',
            top: 3,
            right: 4,
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: '#fff',
            color: '#F5A623',
            fontSize: 11,
            fontWeight: 800,
            lineHeight: '16px',
            textAlign: 'center',
          }}
        >
          !
        </Box>
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          component="p"
          sx={{
            color: '#333333',
            lineHeight: 1.4,
            fontSize: '0.9375rem',
            m: 0,
            wordBreak: 'break-word',
          }}
        >
          Improve Import Success:{' '}
          <Box component="span" sx={{ fontWeight: 800, color: '#111111' }}>
            Review the{' '}
            <Link
              component="button"
              type="button"
              underline="always"
              onClick={downloadDwgGuidelines}
              sx={{
                verticalAlign: 'baseline',
                fontSize: 'inherit',
                fontWeight: 800,
                color: '#1565C0',
                textDecorationColor: '#1565C0',
                p: 0,
                border: 'none',
                background: 'none',
                cursor: 'pointer',
              }}
            >
              DWG Preparation Guidelines
            </Link>{' '}
            for a more seamless experience.
          </Box>
        </Typography>
        <Typography
          sx={{
            display: 'block',
            mt: 0.5,
            color: '#6B6B6B',
            fontSize: '0.8125rem',
            fontWeight: 400,
            lineHeight: 1.35,
          }}
        >
          Click to view our detailed preparation standards.
        </Typography>
      </Box>
    </Box>
  );
}

export default DwgGuidelinesBanner;
